import { Button, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import SettingsProg from "./settings-prog";

const SettingsProgs = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProg, setSelectedProg] = useState(null);

  const getData = () => {
    setLoading(true);
    const progCompany = process.env.REACT_APP_PROG_COMPANY;
    const url = progCompany ? `dict/prog?progCompany=${encodeURIComponent(progCompany)}` : "dict/prog";
    
    serverFetch(url)
      .then((data) => {
        setLoading(false);
        setItems(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAdd = () => {
    setSelectedProg({ id: null });
  };

  const handleEdit = (record) => {
    setSelectedProg({ id: record.id });
  };

  const handleProgClose = (refresh) => {
    setSelectedProg(null);
    if (refresh) {
      getData();
    }
  };



  const columns = [
    {
      dataIndex: "id",
      title: "#",
      width: 60,
    },
    {
      dataIndex: "name",
      title: "Название",
      render: (text, record) => (
        <span
          onClick={() => handleEdit(record)}
          style={{ cursor: "pointer", color: "#1890ff" }}
        >
          {text}
        </span>
      ),
    },
  ];

  return (
    <div className="settings-section-root">
      <div className="settings-section-toolbar">
        <Space>
          <Button type="primary" onClick={handleAdd}>
            Добавить
          </Button>

          <Button onClick={getData} loading={loading}>
            Обновить
          </Button>
        </Space>
      </div>

      <div className="settings-section-scroll">
        <Table
          columns={columns}
          dataSource={items}
          loading={loading}
          rowKey="id"
          pagination={false}
          size="small"
          scroll={{ x: "max-content" }}
          onRow={(record) => ({
            onClick: () => handleEdit(record),
            style: { cursor: "pointer" },
          })}
        />
      </div>

      {selectedProg && (
        <SettingsProg
          progId={selectedProg.id}
          onClose={handleProgClose}
        />
      )}
    </div>
  );
};

export default SettingsProgs;
